export default __webpack_public_path__ + "static/media/pet-images-01.0312a87f.jpg";